import axios from "axios";
import { useQuery } from "react-query"; //QueryClient, useMutation, QueryCache

let baseUrl = "";
window.location.hostname === "localhost"
  ? (baseUrl = "http://mapplugin.test")
  : (baseUrl = window.location.origin);

export const fetchFloors = (obj) =>
  axios
    .get(`${baseUrl}/wp-json/wp/v2/floor`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });

export const useFloors = (obj) =>
  useQuery(["floors", obj], () => fetchFloors(obj), {
    initialData: () => {},
  });

export const fetchShops = (obj) =>
  axios
    .get(
      `${baseUrl}/wp-json/wp/v2/shop?lang=${obj.language ?? "lv"}&per_page=${
        obj.pageSize
      }`
    )
    .then((res) => {
      const result = [];
      res.data.forEach((item) => {
        result.push({
          id: item.id,
          title: item.title.rendered,
          link: item.link,
        });
      });
      return result;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });

export const useShops = (obj) =>
  useQuery(["shops", obj], () => fetchShops(obj), {
    initialData: () => {},
  });

//used for both post and patch for figures on the map
export const postShop = (obj) => {
  const { data, floorId } = obj;

  return axios
    .post(`${baseUrl}/wp-json/wp/v2/floor/${floorId}`, data, {
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": "" + window.wpApiSettings.nonce,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });
};

export const postShopToFigure = (obj) => {
  const { data, shopId } = obj;

  return axios
    .post(`${baseUrl}/wp-json/wp/v2/shop/${shopId}`, data, {
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": "" + window.wpApiSettings.nonce,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });
};

export const deleteFigure = (obj) => {
  const { floorId, figureId } = obj;
  return axios
    .delete(
      `${baseUrl}/wp-json/tc-map/v1/floor/${floorId}/figure/${figureId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": "" + window.wpApiSettings.nonce,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });
};

export const deleteLinkedShops = (obj) => {
  const { floorId, figureId } = obj;
  return axios
    .delete(
      `${baseUrl}/wp-json/tc-map/v1/shop-relations/floor/${floorId}/figure/${figureId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": "" + window.wpApiSettings.nonce,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("ERROR", err);
    });
};
